<script setup>
  defineOptions({
    name: "ComponentOptionsOnMobileIcon",
  });
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    :data-test="getTestId('icon-svg-options-on-mobile')"
  >
    <mask
      id="options-on-mobile-a"
      width="78"
      height="78"
      x="9"
      y="9"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
    >
      <path fill="#D9D9D9" d="M87 9H9v78h78z" />
    </mask>
    <g mask="url(#options-on-mobile-a)">
      <path
        fill="#1C1B1F"
        d="M48.238 79.188q.444 0 .95-.091.507-.09.95-.253l17.12-6.438q1.635-.669 2.587-2.053.95-1.383.95-3.022 0-.219-.344-1.837l-8.581-24.12h4.043l-7.05-10.48a2.06 2.06 0 0 1-.377-1.619q.152-.882.746-1.475l.513-.512L72.05 37.962a8.8 8.8 0 0 1 2.228 2.972 8.6 8.6 0 0 1 .785 3.623v16.756H78V44.557q0-2.532-1.053-4.841a11.7 11.7 0 0 0-2.978-3.991L59.564 23.25l-3.044 3.107-1.494-4.176q-.606-1.7-2.022-2.66-1.416-.959-3.072-.959-.462 0-.99.113a6.3 6.3 0 0 0-.991.294l-17.119 6.437q-1.637.669-2.556 2.063a5.4 5.4 0 0 0-.919 3.031q0 .55.344 1.819l2.181 6.2q-2.544.156-4.056 1.756t-1.513 3.6q0 .657.166 1.281.166.625.516 1.219h-1.62q-2.242 0-3.808 1.566Q18 49.506 18 51.75q0 1.887 1.11 3.212t2.797 1.95q-.413.632-.567 1.347a6.6 6.6 0 0 0-.152 1.366q-.001 2.244 1.534 3.81T26.5 65h1.681q-.35.53-.546 1.219a4.7 4.7 0 0 0-.198 1.281q0 2.244 1.566 3.809 1.566 1.566 3.81 1.566h9.393l.919 2.757q.588 1.717 1.99 2.637a5.58 5.58 0 0 0 3.122.919m-3.775-7.407L31.19 34.601l22.437-8.45 13.275 37.18zm-3.275-1.78h-8.374a2.4 2.4 0 0 1-1.763-.739 2.4 2.4 0 0 1-.737-1.762q0-1.026.737-1.762A2.4 2.4 0 0 1 32.814 65h6.53zm-2.8-7.876H26.501q-1.025 0-1.731-.737a2.46 2.46 0 0 1-.707-1.763q0-1.025.707-1.763a2.3 2.3 0 0 1 1.73-.737h9.982zm-2.862-7.875h-12.15q-1.024 0-1.763-.737a2.4 2.4 0 0 1-.737-1.763q0-1.024.737-1.763a2.4 2.4 0 0 1 1.763-.737h10.388zm-2.863-7.875H29.69a2.4 2.4 0 0 1-1.763-.738 2.4 2.4 0 0 1-.737-1.762q0-1.024.737-1.762a2.4 2.4 0 0 1 1.763-.738H30.9z"
      />
    </g>
    <mask
      id="options-on-mobile-b"
      width="37"
      height="37"
      x="31"
      y="32"
      maskUnits="userSpaceOnUse"
      style="mask-type: alpha"
    >
      <path fill="#D9D9D9" d="m31.596 41.625 26.469-9.133 9.133 26.468-26.469 9.133z" />
    </mask>
    <g mask="url(#options-on-mobile-b)">
      <path
        fill="#1C1B1F"
        d="m42.981 60.561-.7-2.028 2.028-.7.7 2.029zm4.338-1.496-.7-2.028 12.04-4.155.7 2.028zm-6.185-3.856-.701-2.033 2.028-.7.701 2.033zm4.338-1.497-.702-2.033 12.04-4.154.701 2.033zm-6.186-3.86-.7-2.029 2.028-.7.7 2.029zm4.337-1.497-.7-2.028 12.04-4.155.7 2.028z"
      />
    </g>
  </svg>
</template>
